import { AppState } from "../App";

import { BACK_TO_START_SCREEN, BackToStartScreen } from "./appState";

type PumpActivities = number[];

interface PumpMenu {
  pumpActivities: PumpActivities;
}

const INITIAL_STATE: PumpMenu = {
  pumpActivities: [],
};

export const getPumpActivities = (state: AppState) => state.pumpActivity.pumpActivities;

const SET_PUMP_ACTIVITIES = "pumpActivity/SET_PUMP_ACTIVITIES";

interface SetPumpActivities {
  type: typeof SET_PUMP_ACTIVITIES;
  pumpActivities: PumpActivities;
}

type PumpActivityAction = SetPumpActivities | BackToStartScreen;

export const setPumpActivities = (pumpActivities: PumpActivities): SetPumpActivities => {
  return {
    type: SET_PUMP_ACTIVITIES,
    pumpActivities,
  };
};

export default function reducer(state = INITIAL_STATE, action: PumpActivityAction): PumpMenu {
  switch (action.type) {
    case BACK_TO_START_SCREEN:
      return INITIAL_STATE;
    case SET_PUMP_ACTIVITIES: {
      const { pumpActivities } = action;
      return {
        ...state,
        pumpActivities,
      };
    }
    default:
      return state;
  }
}
